import apiInternal from './servers/apiInternal';

export interface RequestPriorityParams {
  platform: string;
  search: string;
  query: string;
  param: {
    key: string;
    value: string;
  };
  callbacks?: Array<{
    url: string;
    method?: 'GET' | 'POST';
  }>;
  makeDownload?: boolean;
  forced?: boolean;
  credentials?: {
    type: 'codilo' | 'aws';
    login: string;
    platform: string;
    codePlatform?: string;
    search?: string;
    key?: string;
  };
  format?: 'default' | 'full';
}

export interface RequestPriorityResponse {
  success: boolean;
  data: any;
}

const requestPriority = {
  create: async (
    level: number,
    params: RequestPriorityParams
  ): Promise<RequestPriorityResponse> => {
    const res = await apiInternal.post(`/request/priority/${level}`, params);
    return res.data;
  },
};

export default requestPriority;
